import debug from 'debug';
import { Action } from 'redux';

import routes from '@configs/routes.json';
import { get } from '@services/method';

type AccountInfoAction = 'GOT_ACCOUNT_INFO';

export type AccountInfo = {
  timezone: string;
  hasSampleLevelDocuments: boolean;
  reportNumberPrefix: string;
};

export interface GetAccountInfoAction extends Action<AccountInfoAction> {
  payload: AccountInfo;
}

const log = debug('store:account-info');

export const getAccountInfo = () => {
  return (dispatch: (action: GetAccountInfoAction) => void) => {
    get(routes.api.account.current)
      .then((response) => response.json())
      .then((accountInfo) =>
        dispatch({ type: 'GOT_ACCOUNT_INFO', payload: accountInfo })
      )
      .catch((error) => {
        log(error);
      });
  };
};
